import config from "../config";

export const PUBLIC_HOME_PAGE = "/";
export const PUBLIC_PRICE_LIST = "/price-list";
export const PUBLIC_SIGN_IN = "/sign-in";
export const PUBLIC_LEADERBOARDS = "/leaderboards";
export const PUBLIC_CALENDAR = "/calendar";
export const PUBLIC_VOUCHER = "/voucher";
export const PUBLIC_RESERVATION = "/reservation";
export const PUBLIC_GALLERY = "/gallery";
export const PUBLIC_PRIVACY = "/privacy";
export const PUBLIC_PATHS = {
    homepage: {
        path: PUBLIC_HOME_PAGE,
        name: "menu.homepage",
        show: true
    },
    priceList: {
        path: PUBLIC_PRICE_LIST,
        name: "menu.priceList",
        show: true
    },
    register: {
        path: PUBLIC_SIGN_IN,
        name: "menu.signIn",
        show: true
    },
    leaderboards: {
        path: PUBLIC_LEADERBOARDS,
        name: "menu.leaderboards",
        show: true
    },
    calendar: {
        path: PUBLIC_CALENDAR,
        name: "menu.calendar",
        show: true
    },
    voucher: {
        path: PUBLIC_VOUCHER,
        name: "menu.voucher",
        show: true
    },
    reservation: {
        path: PUBLIC_RESERVATION,
        name: "menu.reservation",
        show: config.location === 'zilina'
    },
   gallery: {
       path: PUBLIC_GALLERY,
       name: "menu.gallery",
       show: true
   },
   privacy: {
       path: PUBLIC_PRIVACY,
       name: "menu.privacy",
       show: false
   }
}
